import { doc, serverTimestamp, setDoc, writeBatch } from "firebase/firestore";
import { db } from "@/lib/firebase";
import type { Coords } from "@/lib/userLocation";

export async function saveCurrentLocationPreference(uid: string, coords: Coords) {
  const payload = {
    locationPreference: {
      mode: "current",
      coords,
      updatedAt: serverTimestamp(),
    },
  };

  const batch = writeBatch(db);
  batch.set(doc(db, "users", uid), payload, { merge: true });
  batch.set(doc(db, "users", uid, "settings", "preferences"), payload, { merge: true });
  await batch.commit();
}

// NEW: toggle auto-get-current-location on login (writes to both locations)
export async function saveAutoLocationPreference(uid: string, enabled: boolean) {
  const payload = {
    locationPreference: {
      autoOnLogin: enabled,
      updatedAt: serverTimestamp(),
    },
  };

  const batch = writeBatch(db);
  batch.set(doc(db, "users", uid), payload, { merge: true });
  batch.set(doc(db, "users", uid, "settings", "preferences"), payload, { merge: true });
  await batch.commit();
}

export const SETTINGS_LGS_URL = "/settings?lgs=1";
